<mga-toolbar></mga-toolbar>
<router-outlet></router-outlet>
<mga-notification-layout></mga-notification-layout>
